import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private isOpen: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public openSidebar: Observable<boolean>;

  constructor() {
    this.openSidebar = this.isOpen.asObservable();
   }

  toggleSidebar(open) {
    this.isOpen.next(open);
  }

  autotoggleSidebar(){
    this.openSidebar.subscribe(open => {
      this.isOpen.next(open);
    });
  }
}
